import type { FooterLink } from "@/modules/headerFooterFO/Footer/types"

import { useQuery } from "@tanstack/react-query"

import {
  DEFAULT_QUERY_CACHE_TIME as QUERY_CACHE_TIME,
  DEFAULT_QUERY_STALE_TIME as QUERY_STALE_TIME,
} from "@/modules/api/constants"
import { FOOTER_LINKS_QUERY_KEY } from "@/modules/headerFooterFO/Footer/services/constants"
import { getFooterLinks } from "@/modules/headerFooterFO/Footer/services/getFooterLinks"
import { useLocale } from "@/modules/locales/useLocale"
import { HOMEPAGE_HIGHLIGHTED_POSTS_UNLEASH_TOGGLE } from "@/modules/strapi/flags"
import { useFlag } from "@/modules/unleash/hooks/useFlag"

type FooterLinksFetch = {
  dataFooterLinks: FooterLink[]
  isLoadingFooterLinks: boolean
  isSuccessFooterLinks: boolean
  isErrorFooterLinks: boolean
}

export const useFooterLinksFetch = (): FooterLinksFetch => {
  const currentLocale = useLocale()
  const useStrapi = useFlag(HOMEPAGE_HIGHLIGHTED_POSTS_UNLEASH_TOGGLE)
  const {
    data: dataFooterLinks,
    isPending: isLoadingFooterLinks,
    isSuccess: isSuccessFooterLinks,
    isError: isErrorFooterLinks,
  } = useQuery({
    gcTime: QUERY_CACHE_TIME,

    queryFn: () => {
      if (useStrapi) {
        return []
      }

      return getFooterLinks({
        locale: currentLocale,
        useStrapi,
      })
    },
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [FOOTER_LINKS_QUERY_KEY],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataFooterLinks: dataFooterLinks || [],
    isErrorFooterLinks,
    isLoadingFooterLinks,
    isSuccessFooterLinks,
  }
}
